import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Globe, Smartphone, Monitor, ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const platformIcons = {
  Web: Globe,
  Android: Smartphone,
  iOS: Smartphone,
};

const AppsSection = () => {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const res = await axios.get(`${API}/apps`);
        setApps(res.data);
      } catch (err) {
        console.error('Failed to fetch apps:', err);
      }
    };
    fetchApps();
  }, []);

  if (apps.length === 0) return null;

  return (
    <section id="apps" className="section-padding" style={{
      background: '#0f0a1e',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Quantum <span style={{ color: '#00d4ff' }}>Applications</span>
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '15px',
          color: '#b0adc0',
          marginBottom: '12px',
        }}>
          Integrate spiritual practice into your daily digital life with our custom tools.
        </p>
        <div className="section-divider" style={{ marginBottom: '50px' }} />

        <div className="grid-apps">
          {apps.map((app) => {
            const Icon = platformIcons[app.platform] || Monitor;
            return (
              <div
                key={app.app_id}
                className="glass-card"
                style={{
                  padding: '32px',
                  transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    background: 'rgba(139, 92, 246, 0.2)',
                    border: '1px solid rgba(139, 92, 246, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Icon size={24} color="#c4b5fd" />
                  </div>
                  <span style={{
                    background: app.platform === 'Web'
                      ? 'rgba(0, 212, 255, 0.15)'
                      : 'rgba(139, 92, 246, 0.15)',
                    color: app.platform === 'Web' ? '#00d4ff' : '#c4b5fd',
                    padding: '4px 12px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    fontWeight: 500,
                    border: `1px solid ${app.platform === 'Web' ? 'rgba(0, 212, 255, 0.3)' : 'rgba(139, 92, 246, 0.3)'}`,
                  }}>
                    {app.platform}
                  </span>
                </div>

                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#ffffff',
                  marginBottom: '6px',
                }}>
                  {app.title}
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#b0adc0',
                  lineHeight: 1.6,
                  marginBottom: '20px',
                }}>
                  {app.description}
                </p>

                <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
                  {app.tags.map((tag) => (
                    <span
                      key={tag}
                      style={{
                        background: 'rgba(88, 28, 135, 0.2)',
                        color: '#c4b5fd',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        fontSize: '11px',
                        fontWeight: 500,
                        border: '1px solid rgba(139, 92, 246, 0.2)',
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <button
                  onClick={() => { if (app.status === 'available' && app.link && app.link !== '#') window.open(app.link, '_blank'); }}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '12px',
                    border: 'none',
                    background: app.status === 'available'
                      ? 'linear-gradient(135deg, #7c3aed, #a855f7)'
                      : 'rgba(88, 28, 135, 0.3)',
                    color: app.status === 'available' ? 'white' : '#8885a0',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: app.status === 'available' ? 'pointer' : 'default',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    fontFamily: 'Inter, sans-serif',
                  }}
                >
                  {app.status === 'available' ? (
                    <>Launch App <ArrowRight size={16} /></>
                  ) : (
                    'Coming Soon'
                  )}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AppsSection;
